import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pos-diner-assignment-skeleton',
  templateUrl: './diner-assignment-skeleton.component.html',
  styleUrls: ['./diner-assignment-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DinerAssignmentSkeletonComponent {}
